import React from 'react';
import '../../styles/_Home.css';
import { Grid, Row, Col } from "react-bootstrap";
import Phrase from './Phrase';
import Scroll from './Scroll';
import { changeToSpanish, changeToEnglish } from "../../actions/actions";
import { connect } from 'redux-zero/react';

const LanguageBtn = () => {
    return (
        <Row className='lang-change'>
            <div className='left'>
                <a className='es' title='Cambiar idioma a español' onClick={() => changeToSpanish()}><span> ES </span></a>
            </div>
            <div className='right'>
                <span className='actve' onClick={() => changeToEnglish()}> EN </span>
            </div>
        </Row>
    )
}

const PhraseMobile = ({isSpanish}) => {
    return (
        <Row id='phrase_mobile'>
            <Col xs={7} xsOffset={5} lgHidden mdHidden smHidden>
                {isSpanish === true ? <h4>Pasión no es lo que haces bien; es lo que más disfrutas hacer</h4>
                    : <h4>Passion is not what you're good at; it's what you enjoy the most.</h4>}
            </Col>
        </Row>
    )
}

const Home = ({isSpanish}) => {
    return (
        <Grid fluid className='Home'>
            <Scroll />
            <LanguageBtn />
            <Phrase isSpanish={isSpanish}/>
            <PhraseMobile isSpanish={isSpanish}/>
        </Grid>
    )
}

//export default Home;
const mapToProps = ({ isSpanish }) => ({ isSpanish });
export default connect(mapToProps)(Home);


// WEBPACK FOOTER //
// ./src/components/Home/Home.js